import React from 'react';

function OurBenefitsSection() {
  return (
    <section className="benefits-section">
      <div className="container benefits-container">
        
        {/* Left Column: Content + Red Card */}
        <div className="benefits-left">
          
          {/* Badge Label */}
          <div className="benefits-badge-row">
            <span className="benefits-badge">Our Benefits</span>
            <span className="benefits-badge-line"></span>
          </div>

          {/* Heading */}
          <h2 className="benefits-title">
            What You Get When Partnering With Us?
          </h2>

          {/* Description */}
          <p className="benefits-description">
            When you choose Experts Communication, you do not just hire a service provider – you gain a strategic partner who is committed to your success. See the difference that true partnership and dedication can make for your business growth.
          </p>

          {/* Solid Red Highlight Box */}
          <div className="benefits-red-card">
            <div className="benefits-red-col">
              <h3 className="benefits-red-title">Cost Effective</h3>
              <p className="benefits-red-desc">
                We provide cost-effective solutions that reduce your operational costs and maintain premium quality standards.
              </p>
            </div>

            <div className="benefits-red-col">
              <h3 className="benefits-red-title">Scalable Growth</h3>
              <p className="benefits-red-desc">
                Our team delivers adaptable solutions that grow with your business, be it startup operations or enterprise-level requirements.
              </p>
            </div>
          </div>

        </div>

        {/* Right Column: Image with Curved Corners */}
        <div className="benefits-right">
          <div className="benefits-img-wrapper">
            <img 
              src="/assets/images/team-moc3.jpg" 
              alt="Partnering With Experts Communication" 
              className="benefits-img"
            />
          </div>
        </div>

      </div>
    </section>
  );
}

export default OurBenefitsSection;
